import React from 'react';
import { WidgetType } from '../../types/api/ElementType';
import { Widget } from '../../_lib/components/Widget';
import { getWidgetHeaderId } from '../../_lib/components/Widget/Widget.utils';
import { ExecutiveOrganisationChartPrintBlock } from
  '../../_blocks/ExecutiveOrganisationChartPrintBlock/ExecutiveOrganisationChartPrintBlock';

export function ExecutiveOrganisationChartPrintWidget(props: any) {
  const block = props.blocks?.[0];

  return (
    <Widget
      uuid={props.uuid}
      widgetType={WidgetType.gvpprint}
      aria-labelledby={getWidgetHeaderId(WidgetType.gvpprint, props.uuid)}
    >
      {block && (
        <ExecutiveOrganisationChartPrintBlock {...block} />
      )}
    </Widget>
  );
}
